import React from 'react';
import {DmsTab} from 'Components';
import {Form, Input, Select, Button, Row, Col, Tree, TreeSelect, message,Icon} from 'antd';
const Option = Select.Option;
const FormItem = Form.Item;
const TreeNode = Tree.TreeNode;
import {areaDetail, allChildren, areaDelete, areaAdd, areaModify} from '../../service/zone';
import {treeByParentId} from '../../service/region';
import {nameValidator,checkCode} from '../../utils/regexp.js';
import {showSpin,hideSpin} from 'Utils';

class Zone extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			opts: ['区域管理'],
			tree: [],
			selectkey: null,
			detail: {},
			regionTree: [],
			editFlag:false,//编辑
			rootFlag:false,//上一级
			childFlag:false,//下一级
			buttonFlag:true,//按钮
			disabledFlag:true,
			keys:[],
			regionFlag:true,//管理区域
			regionIdArr:[],
			regionNameList:[],
			hasFeedback:false
		};
		this.onSelect = this.onSelect.bind(this);
		this.getData = this.getData.bind(this);
		this.getRegionTree = this.getRegionTree.bind(this);
		this.getChildren = this.getChildren.bind(this);
		this.getNewTreeData = this.getNewTreeData.bind(this);
		this.deleteArea=this.deleteArea.bind(this);
		this.checkSortOrder=this.checkSortOrder.bind(this);
	}

	componentDidMount() {
		this.getData();
		this.getRegionTree(1, 1);
	}


	getData() {
		allChildren({id: 0}).then(result => {
			if (result.status) {
				this.setState({
					tree: result.data
				})
			} else {
				message.error(result.message);
			}
		})
	}

	getRegionTree(parentId, level) {
		treeByParentId(parentId).then(result => {
			if (result.status) {
				let str = JSON.stringify(result.data);
				str.replace(/leaf/g, 'isLeaf');
				var newTreeStr = str.replace(/leaf/g, 'isLeaf');
				this.setState({
					regionTree: JSON.parse(newTreeStr).map(x => {
						return {
							...x,
							level
						}
					})
				})
			} else {
				message.error(result.message);
			}
		})
	}


	getNewTreeData(treeData, curKey, child, level) {
		const loop = (data) => {
			if (level < 1) return;
			data.forEach((item) => {
				if (curKey === item.key) {
					item.children = child;
				} else if (item.hasOwnProperty('children') && item.children !== null) {
					loop(item.children);
				}
			});
		};
		loop(treeData);
	}

	getChildren(node) {
		const self = this;
		const parentId = parseInt(node.props.value, 10);
		const destLevel = node.props.level + 1;

		return new Promise((resolve, reject) => {
			treeByParentId(parentId, destLevel).then(result => {
				if (result.status) {
					let str = JSON.stringify(result.data);
					var newChildStr = str.replace(/leaf/g, 'isLeaf');
					var childrenList = JSON.parse(newChildStr);
					childrenList.forEach(x => {
						x['level'] = destLevel
					})

					const regionTree = [...self.state.regionTree];

					self.getNewTreeData(regionTree, node.props.eventKey, childrenList, destLevel);
					self.setState({regionTree}, () => {
						resolve();
					});
				} else {
					message.error(result.message);
					reject(result.message);
				}
			})
		})
	}


	onSelect(selectedKeys, info) {
		if (selectedKeys.length != 0) {
			this.setState({
				keys:selectedKeys,
				childFlag:false,
				editFlag:false,
				rootFlag:false,
				buttonFlag:false,
				disabledFlag:true,
				regionFlag:true,
				hasFeedback:false
			});
			const {setFieldsValue} = this.props.form;
			areaDetail({id: parseInt(selectedKeys[0],0)}).then(result => {
				var regionIdArr =[];
				var regionNameList=[];
				if (result.status) {
					if (result.data.active === 1) {
						result.data.active = '有效';
					} else {
						result.data.active = '无效';
					}
					if (result.data.regionId && result.data.regionId.length >0) {
						if (result.data.regionId.indexOf(',' != -1)) {
							regionIdArr = result.data.regionId.split(',');
							 regionNameList = result.data.regionName.split(';');
						} else {
							regionNameList.push(result.data.regionName);
							regionIdArr.push(result.data.regionId);
						}
					} else {
						regionNameList = [];

					}
					this.setState({
						regionIdArr,
						regionNameList,
						detail: result.data,
						selectkey:parseInt(selectedKeys[0],0)
					})
					setFieldsValue({
						name: result.data.name,
						areaCode: result.data.areaCode,
						sortOrder: result.data.sortOrder,
						active: result.data.active
					});
				} else {
					message.error(result.message);
				}
			})
		}else{
			this.cancelHandle();
		}
	}

	//编辑
	editHandle() {
		if (this.state.selectkey != null) {
			this.setState({
				childFlag:false,
				editFlag:true,
				rootFlag:false,
				disabledFlag:false,
				regionFlag:true,
				hasFeedback:true
			});
		}else{
			this.cancelHandle();
		}
	}

	//删除
	deleteHandle() {
		if(this.state.selectkey!=null){
			areaDelete(this.state.detail.id).then(result => {
				if (result.status) {
					message.success('删除成功');
					this.getData();
					this.cancelHandle();
				}else{
					message.error(result.message);
				}
			})
		}else{
			message.info('请选择要删除的区域');
		}
	}

	//添加上一级
	upSumbit() {
		this.setState({
			childFlag:false,
			editFlag:false,
			rootFlag:true,
			disabledFlag:false,
			regionFlag:false,
			keys:[],
			hasFeedback:true
		});
		const {setFieldsValue} = this.props.form;
		if(this.state.editFlag||this.state.childFlag){
			setFieldsValue({
				name: '',
				areaCode: '',
				active: '',
				areaIdList: [],
				sortOrder: ''
			});
		}else{
			setFieldsValue({
				name: '',
				areaCode: '',
				active: '',
				sortOrder: ''
			});
		}
	}


	//添加下一级
	downSumbit() {
		if(this.state.selectkey!=null){
			this.setState({
				childFlag:true,
				editFlag:false,
				rootFlag:false,
				disabledFlag:false,
				regionFlag:false,
				hasFeedback:true
			});
			const {setFieldsValue} = this.props.form;
			if(this.state.editFlag||this.state.rootFlag){
				setFieldsValue({
					name: '',
					areaCode: '',
					active: '',
					areaIdList: [],
					sortOrder: ''
				});
			}else{
				setFieldsValue({
					name: '',
					areaCode: '',
					active: '',
					sortOrder: ''
				});
			}
		}else{
			this.setState({
				childFlag:false,
				editFlag:false,
				rootFlag:false,
				disabledFlag:true,
				regionFlag:false,
				hasFeedback:false
			})
			message.info('请选择上级区域');
		}
	}


	cancelHandle() {
		this.setState({
			childFlag:false,
			editFlag:false,
			rootFlag:false,
			buttonFlag:true,
			disabledFlag:true,
			regionFlag:false,
			keys:[],
			hasFeedback:false
		});
		const {setFieldsValue} = this.props.form;
		setFieldsValue({
			name: '',
			areaCode: '',
			active: '',
			areaIdList: [],
			sortOrder: ''
		});
	}

	submitHandle() {
		const {editFlag,childFlag,rootFlag,regionIdArr}=this.state;
		if(editFlag===false&&childFlag===false&&rootFlag===false){
			message.info('请选择要进行何种操作');
		}else {
			const {validateFields, getFieldsValue} = this.props.form;
			validateFields((errors) => {//表单校验
				if (errors) {
					return
				}//表单校验有误，则不执行下面的代码
				const data = {
					...getFieldsValue() //获取用户输入
				};
				if (data.active === '1' || data.active === '有效') {
					data.active = 1;
				} else {
					data.active = 0;
				}

        showSpin();
				//编辑
				if(editFlag===true&&childFlag===false&&rootFlag===false){
					if (data.areaIdList != undefined && data.areaIdList.length > 0) {
						if (data.areaIdList.length === 1&&regionIdArr.length===0) {
							data.regionId = data.areaIdList[0];
						} else if(data.areaIdList.length === 1&&regionIdArr.length>0){
							var regionIdStr=regionIdArr.join(';');
							data.regionId=data.areaIdList+";"+regionIdStr;
						}else if(data.areaIdList.length>1&&regionIdArr.length===0){
							var editStr = '';
							for (var e = 0; e < data.areaIdList.length; e++) {
								editStr += data.areaIdList[e] + ';';
							}
							data.regionId = editStr.substring(0, editStr.length - 1);
						}else{
							var edit = '';
							for (var t = 0; t < data.areaIdList.length; t++) {
								edit += data.areaIdList[t] + ';';
							}
							var regionIdstr=regionIdArr.join(';');
							data.regionId = edit+regionIdstr;
						}
					} else {
						if(regionIdArr){
							var regionIdData=regionIdArr.join(';');
							data.regionId = regionIdData;
						}
					}
					data.id = this.state.detail.id;
					data.parentAreaId = this.state.detail.parentAreaId;
					areaModify(data).then(result => {
						hideSpin();
						if (result.status) {
							this.getData();
							this.cancelHandle();
							message.success('修改成功');
						}else{
							message.error(result.message);
						}
					})
				}
				//新增上一级
				if(editFlag===false&&childFlag===false&&rootFlag===true){
					if (data.areaIdList != undefined && data.areaIdList.length > 0) {
						if (data.areaIdList.length === 1) {
							data.regionId = data.areaIdList[0];
						}else{
							var editArea = '';
							for (var d = 0; d < data.areaIdList.length; d++) {
								editArea += data.areaIdList[d] + ';';
							}
							data.regionId = editArea.substring(0, editArea.length - 1);
						}
					} else {
							data.regionId = '';
					}
					data.parentAreaId = 0;
					areaAdd(data).then(result=>{
						hideSpin();
						if(result.status){
							this.getData();
							this.cancelHandle();
							message.success('添加成功');
						}else{
							message.error(result.message);
						}
					})
				}
				//新增下一级
				if(editFlag===false&&childFlag===true&&rootFlag===false){
					if (data.areaIdList != undefined && data.areaIdList.length > 0) {
						if (data.areaIdList.length === 1) {
							data.regionId = data.areaIdList[0];
						}else{
							var editZone = '';
							for (var z = 0; z < data.areaIdList.length; z++) {
								editZone += data.areaIdList[z] + ';';
							}
							data.regionId = editZone.substring(0, editZone.length - 1);
						}
					} else {
						data.regionId = '';
					}
					data.parentAreaId = this.state.detail.id;
					areaAdd(data).then(result=>{
						hideSpin();
						if(result.status){
							this.getData();
							this.cancelHandle();
							message.success('添加成功');
						}else{
							message.error(result.message);
						}
					})
				}

			})
		}

	}

	deleteArea(key){
		const {regionIdArr,regionNameList} =this.state;
		regionIdArr.splice(key,1);
		regionNameList.splice(key,1);
		this.setState({
			regionNameList,
			regionIdArr
		});
	}

	//排序正则
	checkSortOrder(rule, value, callback) {
		const vaReg = /^\d{1,}$/;
		if (value) {
			if (!(vaReg.test(value))) {
				callback('排序只可输入整数');
			}
			callback();
		}
		callback();
	}


	render() {
		const {opts, detail,buttonFlag,disabledFlag,keys,regionFlag,regionNameList,editFlag,regionIdArr,hasFeedback} = this.state;
		const {getFieldDecorator} = this.props.form;
		const self=this;
		const loop = data => data.map((item, key) => {
			if (item.children && item.children.length) {
				return <TreeNode key={item.key} title={item.label}>{loop(item.children)}</TreeNode>;
			}
			return <TreeNode key={item.key} title={item.label}/>;
		});

		return <div className='dms-body'>
			<DmsTab options={opts} defaultKey={0}>
				<Button onClick={this.upSumbit.bind(this)}>+新增上一级</Button>
				<Button disabled={buttonFlag} onClick={this.downSumbit.bind(this)}>+新增下一级</Button>
				<Button disabled={buttonFlag} onClick={this.editHandle.bind(this)}>编辑当前区域</Button>
				<Button disabled={buttonFlag} onClick={this.deleteHandle.bind(this)}>删除当前区域</Button>
			</DmsTab>
			<div className="dms-table-box"
				 style={{backgroundColor: "#fff", padding: '20px 5% 20px 35%', minHeight: '350px'}}>

				<div className="left"
					 style={{
						 width: "27%",
						 display: 'inline-block',
						 height: '90%',
						 overflow: 'auto',
						 marginRight: '3%',
						 position: 'absolute',
						 left: '5%',
						 top: '20px'
					 }}>
					<Tree
						autoExpandParent
						onSelect={this.onSelect}
						selectedKeys={keys}
					>
						{loop(this.state.tree)}
					</Tree>
				</div>

				<div className='right' style={{width: "100%", display: 'inline-block'}}>
					<Form layout="horizontal" style={{width: '100%'}}>
						<Row gutter={16}>
							<Col className="gutter-row" span={12}>
								<FormItem label="区域名称" hasFeedback={hasFeedback}>
									{getFieldDecorator('name', {
										rules: [
											{
												required: true,
												message: '请输入区域名称'
											},
											{
												validator: nameValidator
											}
										],
									})(<Input disabled={disabledFlag} placeholder="请输入区域名称"/>)}
								</FormItem>
							</Col>
							<Col className="gutter-row" span={12}>
								<FormItem label="区域编码" hasFeedback={hasFeedback}>
									{getFieldDecorator('areaCode', {
										rules: [
											{
												required: true,
												message: '请输入区域编码'
											},
											{
												validator: checkCode
											}
										]
									})(<Input disabled={disabledFlag} placeholder="请输入区域编码"/>)}
								</FormItem>
							</Col>
						</Row>

						<Row gutter={16}>
							<Col className="gutter-row" span={12}>
								<FormItem label="有效性">
									{getFieldDecorator('active', {
										rules: [
											{
												required: true,
												message: '请选择是否有效'
											},
										]
									})(<Select disabled={disabledFlag}>
										<Option value='1'>有效</Option>
										<Option value='0'>无效</Option>
									</Select>)}
								</FormItem>
							</Col>
							<Col className="gutter-row" span={12}>
								<FormItem label="排序">
									{getFieldDecorator('sortOrder',{
										rules: [
											{
												validator: this.checkSortOrder
											}
										]
									})(<Input disabled={disabledFlag} />)}
								</FormItem>
							</Col>
						</Row>

						<Row>

							{
								(detail != null && detail.regionId&&regionFlag&&regionIdArr.length>0) ?
									<div>
									<div style={{marginBottom: '20px'}}>
										<p>当前管理地区:</p>
										{
											regionNameList.map(function (item, key) {
												return <p key={key}><span>{`${key + 1}.${item}`}</span>&nbsp;&nbsp;&nbsp;{
													editFlag?
													<Icon
														style={{color: '#d61518',fontSize:'16px',fontWeight:'600'}}
														type="close" onClick={self.deleteArea.bind(this,key)}/>
														:
														''
												}
												</p>
											})
										}
									</div>
										{
											editFlag?
												<FormItem label="管理地区">
													{getFieldDecorator('areaIdList', {
														rules: [
															{
																required: (detail != null && detail.regionId &&regionFlag&&regionIdArr.length>0) ? false : true,
																message: '请选择管理地区'
															},
														]
													})(<TreeSelect
														dropdownStyle={{maxHeight: '150px', overflow: 'auto'}}
														style={{width: '100%'}}
														placeholder="请选择管理地区"
														allowClear
														showCheckedStrategy='SHOW_PARENT'
														multiple={true}
														disabled={disabledFlag}
														treeData={this.state.regionTree}
														treeCheckable={true}
														loadData={this.getChildren}
													/>)}
												</FormItem>
												:
												''
										}
									</div>
									:
									<FormItem label="管理地区">
										{getFieldDecorator('areaIdList', {
											rules: [
												{
													required: true,
													message: '请选择管理地区'
												},
											]
										})(<TreeSelect
											dropdownStyle={{maxHeight: '150px', overflow: 'auto'}}
											style={{width: '100%'}}
											placeholder="请选择管理地区"
											allowClear
											showCheckedStrategy='SHOW_PARENT'
											multiple={true}
											disabled={disabledFlag}
											treeData={this.state.regionTree}
											treeCheckable={true}
											loadData={this.getChildren}
										/>)}
									</FormItem>
							}

						</Row>

					</Form>

					{
						disabledFlag?
							''
							:
							<div style={{textAlign:'center'}}>
								<Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
								<Button style={{marginLeft:'20px'}} onClick={this.cancelHandle.bind(this)}>取消</Button>
							</div>
					}

				</div>

			</div>
		</div>
	}
}
;

export default Form.create()(Zone);



// WEBPACK FOOTER //
// ./src/routes/zone/index.js